import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import userImage from '../../assets/images/user.jpeg';
import { logout } from '../../store/actions/user';
import useWindowSize from '../../hooks/useWindowSize';

function AccountPanel() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lang = Cookies.get('i18next') || 'en';
  const { user } = useSelector((state) => state.users);
  const { translations } = useSelector((state) => state.translation);
  const [panelPages, setPanelPages] = useState([]);
  useEffect(() => {
    setPanelPages([
      {
        id: 1,
        title: translations ? translations.profile_information[lang] : '',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" strokeOpacity="0.6" cy="6" r="4" stroke="currentColor" strokeWidth="1.5" />
            <ellipse strokeOpacity="0.6" cx="12" cy="17" rx="7" ry="4" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        ),
        page: 'profile',
      },
      {
        id: 2,
        title: translations ? translations.profile_password[lang] : '',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 4H10C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H12M15 4.00093C18.1143 4.01004 19.7653 4.10848 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.7653 19.8915 18.1143 19.99 15 19.9991"
              stroke="currentColor"
              strokeOpacity="0.6"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z"
              fill="currentColor"
              fillOpacity="0.6"
            />
            <path
              d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
              fill="currentColor"
              fillOpacity="0.6"
            />
            <path
              d="M15 2V22"
              stroke="currentColor"
              strokeOpacity="0.6"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        ),
        page: 'password',
      },
      {
        id: 3,
        title: translations ? translations.profile_history[lang] : '',
        page: 'history',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 8V12L14.5 14.5"
              stroke="currentColor"
              strokeOpacity="0.6"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.60414 5.60426L5.07381 5.07393V5.07393L5.60414 5.60426ZM4.33776 6.87064L3.58777 6.87441C3.58984 7.28568 3.92272 7.61857 4.33399 7.62063L4.33776 6.87064ZM6.87954 7.63343C7.29375 7.63551 7.63122 7.30141 7.6333 6.8872C7.63538 6.473 7.30129 6.13553 6.88708 6.13344L6.87954 7.63343ZM5.07496 4.32132C5.07288 3.90711 4.73541 3.57302 4.3212 3.5751C3.90699 3.57718 3.5729 3.91465 3.57498 4.32886L5.07496 4.32132ZM3.82661 10.785C3.88286 10.3747 3.59578 9.99639 3.1854 9.94014C2.77503 9.88389 2.39675 10.171 2.3405 10.5813L3.82661 10.785ZM18.8622 5.13789C15.042 1.3177 8.86873 1.27901 5.07381 5.07393L6.13447 6.13459C9.33358 2.93549 14.5571 2.95407 17.8016 6.19855L18.8622 5.13789ZM5.13777 18.8624C8.95796 22.6825 15.1313 22.7212 18.9262 18.9263L17.8655 17.8657C14.6664 21.0648 9.44291 21.0462 6.19843 17.8017L5.13777 18.8624ZM18.9262 18.9263C22.7211 15.1314 22.6824 8.95808 18.8622 5.13789L17.8016 6.19855C21.0461 9.44303 21.0646 14.6665 17.8655 17.8657L18.9262 18.9263ZM5.07381 5.07393L3.80743 6.34031L4.86809 7.40097L6.13447 6.13459L5.07381 5.07393ZM4.33399 7.62063L6.87954 7.63343L6.88708 6.13344L4.34153 6.12065L4.33399 7.62063ZM5.08775 6.86687L5.07496 4.32132L3.57498 4.32886L3.58777 6.87441L5.08775 6.86687ZM2.3405 10.5813C1.93907 13.51 2.87392 16.5985 5.13777 18.8624L6.19843 17.8017C4.27785 15.8811 3.48663 13.2653 3.82661 10.785L2.3405 10.5813Z"
              fill="currentColor"
              fillOpacity="0.6"
            />
          </svg>
        ),

      },
      // {
      //   id: 4,
      //   title: translations ? translations.profile_results[lang] : '',
      //   page: 'results',
      //   icon: (
      //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      //       <path
      //         d="M16 4.00171C18.175 4.01382 19.3529 4.11027 20.1213 4.87865C21 5.75733
      //         21 7.17154 21 9.99997V16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426
      //         22 17.8284 22 15 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284
      //         3 16V9.99997C3 7.17154 3 5.75733 3.87868 4.87865C4.64706
      //         4.11027 5.82497 4.01382 8 4.00171"
      //         stroke="currentColor"
      //         strokeOpacity="0.6"
      //         strokeWidth="1.5"
      //       />
      //       <path d="M7 14.5H15" stroke="currentColor" strokeOpacity="0.6"
      //       strokeWidth="1.5" strokeLinecap="round" />
      //       <path d="M7 18H12.5" stroke="currentColor" strokeOpacity="0.6"
      //       strokeWidth="1.5" strokeLinecap="round" />
      //       <path
      //         d="M8 3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157
      //         16 3.5V4.5C16 5.32843 15.3284 6 14.5 6H9.5C8.67157 6 8 5.32843 8 4.5V3.5Z"
      //         stroke="currentColor"
      //         strokeOpacity="0.6"
      //         strokeWidth="1.5"
      //       />
      //     </svg>
      //   ),
      // },
      // {
      //   id: 5,
      //   title: translations ? translations.profile_bonuses[lang] : '',
      //   page: 'bonuses',
      //   icon: (
      //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      //       <g clipPath="url(#clip0_183_2507)">
      //         <path
      //           d="M12 0.1875C5.487 0.1875 0.1875 5.487 0.1875 12C0.1875 18.513 5.487
      //           23.8125 12 23.8125C18.513 23.8125 23.8125 18.513 23.8125 12C23.8125 5.487 18.513
      //           0.1875 12 0.1875ZM12 22.6875C6.1065 22.6875 1.3125 17.8935
      //           1.3125 12C1.3125 6.1065
      //           6.1065 1.3125 12 1.3125C17.8935 1.3125 22.6875 6.1065 22.6875
      //           12C22.6875 17.8935 17.8935 22.6875 12 22.6875Z"
      //           fill="currentColor"
      //           fillOpacity="0.6"
      //         />
      //         <path
      //           d="M12 3.1875C7.14 3.1875 3.1875 7.1415 3.1875 12C3.1875 16.8585 7.1415
      //           20.8125 12 20.8125C16.8585 20.8125 20.8125 16.8585 20.8125 12C20.8125
      //           7.1415 16.8585 3.1875 12 3.1875ZM12 19.6875C7.761 19.6875 4.3125 16.239
      //           4.3125 12C4.3125 7.761 7.761
      //           4.3125 12 4.3125C16.239 4.3125 19.6875 7.761 19.6875 12C19.6875
      //           16.239 16.239 19.6875 12 19.6875Z"
      //           fill="currentColor"
      //           fillOpacity="0.6"
      //         />
      //         <path
      //           d="M16.8112 10.005L13.8352 9.57301L12.5032 6.87601C12.3127 6.49201 11.6857
      //           6.49201 11.4952 6.87601L10.1632 9.57301L7.1872 10.0065C7.08288 10.021
      //           6.98473 10.0645 6.90398 10.1321C6.82323 10.1997 6.76315 10.2887 6.73059
      //           10.3888C6.69804 10.489 6.69434 10.5963 6.71992 10.6984C6.74549 10.8006
      //           6.7993 10.8935 6.8752 10.9665L9.0292 13.065L8.5192 16.0305C8.50138
      //           16.1341 8.51295 16.2406 8.55259 16.338C8.59222 16.4353 8.65835 16.5196
      //           8.74346 16.5813C8.82857 16.643 8.92926 16.6796 9.03412 16.687C9.13897 16.6943
      //           9.2438 16.6722 9.3367 16.623L11.9992 15.2235L14.6617 16.623C14.7545 16.6724
      //           14.8593 16.6947 14.9642 16.6874C15.069 16.6801 15.1697 16.6435 15.2548
      //           16.5817C15.3399 16.5199 15.4059 16.4355 15.4453 16.3381C15.4847 16.2406
      //           15.4959 16.134 15.4777 16.0305L14.9692
      //           13.065L17.1232 10.965C17.1991 10.892 17.2529
      //           10.7991 17.2785 10.6969C17.3041 10.5948 17.3004 10.4875 17.2678 10.3873C17.2353
      //           10.2872 17.1752 10.1982 17.0944 10.1306C17.0137 10.063 16.9155 10.0195 16.8112
      //           10.005ZM13.9717 12.465C13.9064 12.529 13.8576 12.6079 13.8296 12.6949C13.8017
      //           12.7819 13.7953 12.8745 13.8112 12.9645L14.1772 15.096L12.2602 14.091C12.1797
      //           14.0486 12.0902 14.0264 11.9992 14.0264C11.9082 14.0264
      //           11.8187 14.0486 11.7382 14.091L9.8212
      //           15.096L10.1872 12.9645C10.2028 12.8747 10.1963 12.7825
      //           10.1684 12.6957C10.1404 12.609 10.0918 12.5303 10.0267
      //           12.4665L8.4742 10.956L10.6162 10.644C10.7066
      //           10.6312 10.7926 10.5965 10.8666 10.5429C10.9406 10.4893
      //           11.0003 10.4185 11.0407 10.3365L11.9992 8.39701L12.9562
      //           10.3365C13.0387 10.503 13.1962 10.6185 13.3807
      //           10.644L15.5227 10.956L13.9717 12.465Z"
      //           fill="currentColor"
      //           fillOpacity="0.6"
      //         />
      //       </g>
      //       <defs>
      //         <clipPath id="clip0_183_2507">
      //           <rect width="24" height="24" fill="white" />
      //         </clipPath>
      //       </defs>
      //     </svg>
      //   ),
      // },
    ]);
  }, [translations]);
  const handleLogout = () => {
    dispatch(logout());
    window.location.href = `/${lang}`;
  };
  const handleNavigate = (url) => {
    navigate(`/${lang}/account/${url}`);
  };

  const { page } = useParams();
  const { width } = useWindowSize();
  return (
    <div className="user__account-panel">
      <div className="user-info">
        <img src={user.image_path ? user.image_path : userImage} alt="" />
        <div className="user-info-box">
          <p className="user-info-name">
            {user.first_name}
            {' '}
            {user.last_name}
          </p>
          <p className="user-info-email">{user.email}</p>
        </div>
      </div>
      <div className="user__account-panel-pages">
        {panelPages.map((item) => (
          <div
            key={item.id}
            role="presentation"
            onClick={() => handleNavigate(item.page)}
            className={`user__account-panel-item ${
              page === item.page || ((!page && width > 768) && item.page === 'profile') ? 'active' : ''
            }`}
          >
            <div className="user__account-panel-icon">{item.icon}</div>
            <p className="user__account-panel-title">{item.title}</p>
          </div>
        ))}
      </div>
      <div onClick={handleLogout} role="presentation" className="user__account-panel-item  log-out">
        <div className="user__account-panel-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 7C9.01211 4.82497 9.10856 3.64706 9.87694 2.87868C10.7556 2 12.1698 2 14.9983 2L15.9983 2C18.8267 2 20.2409 2 21.1196 2.87868C21.9983 3.75736 21.9983 5.17157 21.9983 8L21.9983 16C21.9983 18.8284 21.9983 20.2426 21.1196 21.1213C20.2409 22 18.8267 22 15.9983 22H14.9983C12.1698 22 10.7556 22 9.87694 21.1213C9.10856 20.3529 9.01211 19.175 9 17"
              stroke="#384754"
              strokeOpacity="0.6"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M15 12L2 12M2 12L5.5 9M2 12L5.5 15"
              stroke="#384754"
              strokeOpacity="0.6"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="user__account-panel-title">{translations.log_out[lang]}</p>
      </div>
    </div>
  );
}

export default AccountPanel;
